import { useQuery } from "@tanstack/react-query";
import { getQuadMedia, type QuadMediaParams } from "./quadmedia.api";
import { useQuadMediaApiToken } from "@/features/auth/hooks/useApiToken";

export function useQuadMediaQuery(
  params: QuadMediaParams,
  dateRange?: string,
  limit?: number,
  enabled: boolean = true,
) {
  const { apiToken } = useQuadMediaApiToken();

  const queryParams: QuadMediaParams = {
    ...params,
    dateRange: dateRange,
    limit: limit,
  };

  return useQuery({
    queryKey: ["quadmedia", queryParams],
    queryFn: () => getQuadMedia(queryParams, apiToken),
    enabled:
      enabled &&
      Boolean(
        params.print_ids?.length ||
          params.online_news_ids?.length ||
          params.tv_ids?.length ||
          params.radio_ids?.length,
      ) &&
      Boolean(apiToken) &&
      Boolean(dateRange),
  });
}
